const INVOICE_TYPE = {
  BUDGET_INVOICE_TYPE: 'Budget',
  COURSE_INVOICE_TYPE: 'Course',
};
/**
 * Enum definition.
 *
 * @type {string[]}
 */
const INVOICE_TYPE_ENUM = Object.keys(INVOICE_TYPE);

const BUDGET_INVOICE_TYPE = INVOICE_TYPE_ENUM[0];
const COURSE_INVOICE_TYPE = INVOICE_TYPE_ENUM[1];

export {
  INVOICE_TYPE_ENUM,
  INVOICE_TYPE,
  BUDGET_INVOICE_TYPE,
  COURSE_INVOICE_TYPE,
};
